import { render, staticRenderFns } from "./PerStatement.vue?vue&type=template&id=036e8698&scoped=true"
import script from "./PerStatement.vue?vue&type=script&lang=js"
export * from "./PerStatement.vue?vue&type=script&lang=js"
import style0 from "./PerStatement.vue?vue&type=style&index=0&id=036e8698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e8698",
  null
  
)

export default component.exports